import Axios from './Axios';

const API_URL = '/doctor-profile-management/';
export const InfoService = {
  getInfo: (id) => Axios.get(API_URL + 'info/' + id),
  updateInfo: (id, body) => Axios.patch(API_URL + 'info/' + id, body),
  recommended: (body) => Axios.patch(API_URL + 'update-recommended', body)
};
